import { Component, OnInit } from '@angular/core';
import {UserService} from "../../Services/Users.service";
import {AuthService} from "../../Services/AuthGard.service";
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalService} from "../../Services/global.service";
import * as CryptoJS from 'crypto-js';
import {TranslateService} from "@ngx-translate/core";
import {CookieService} from "ngx-cookie-service";
declare var $;
@Component({
  selector: 'app-isolated-login',
  templateUrl: './isolated-login.component.html',
  styleUrls: ['./isolated-login.component.css'],
  providers: [AuthService]
})
export class IsolatedLoginComponent implements OnInit {

  user_name:string;
  privacyField: boolean = false;
  recoverUser:boolean = false;
  password:string;
  loginStatusCode : string = "";
  validationMsg : string;
  loginflag : boolean;
  emailValidMsg : string;
  AllCommunities = [];
  securityQuestions : Array<any> = [];
  receiver: string;
  question:string;
  //answer:string;
  alignorStstusCode : string = "";
  personalStstusCode : string = "";
  companyName:string;
  email_id:string;
  answer:string;
  isDataShow: boolean = false;
  screenWidth: number = 1366;
  screenHeight: number ;
  redirectUrl: string = '';
  buttonTitle: any;
  passwordType: boolean = false;

  constructor(private AuthService : AuthService, private userService : UserService, private router : Router,
              private route: ActivatedRoute, private globalService : GlobalService, private translate: TranslateService,
              private cookieService: CookieService) {
    let lang_name = 'English';
    this.translate.reloadLang(lang_name);
  }

  ngOnInit() {
    $("header").css('display','none');
    $("footer").css('display','none');
    $("body").addClass("isolatedBg");
    let value;
    $(window).on('popstate', function() {
      location.reload(true);
    });
    window.name = 'isolatedLoginScreen';
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;

    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
      } else {
        this.screenWidth = screen.width || window.screen.width;
      }
    });
    // localStorage.clear();
    // localStorage.clear();
    this.isDataShow = true;
    this.translate.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY']).subscribe(label =>{
      this.buttonTitle = label;
    });
    $('.modal-backdrop').css('display', 'none');
    $("#preloader").css('display','none');
    this.route.params.subscribe(params => {
      if(params['url']){
        let id = params['url'];
        if(id && id.includes('http')){
          this.redirectUrl = decodeURIComponent(id);
        }else{
          value = params['url']; // (+) converts string 'id' to a number
          if(value){
            this.userService.getCommunityNameByCommunityID(value).subscribe(comm=> {
              if(comm.success && comm.data){
                let commResObj = {
                  community_id : comm.data.comm_id,
                  community_name : comm.data.comm_name,
                  resource_config : comm.data.resource_config
                };
                localStorage.setItem('CommResources', JSON.stringify(commResObj));

                let defaultLangData = this.cookieService.get('defaultLangData') ? JSON.parse(this.cookieService.get('defaultLangData')) : null;

                let lang_name = defaultLangData.lang_name ? defaultLangData.lang_name : (localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English');

                this.translate.use(lang_name);
                this.translate.reloadLang(lang_name);
                this.translate.get(['LOGIN_SERVER_MSG.INVALID_CREDENTIALS', 'LOGIN_SERVER_MSG.INACTIVE_COMMUNITY']).subscribe(label =>{
                  this.buttonTitle = label;
                });
                this.userService.getCommunityLogo(comm.data.comm_id).subscribe(res => {
                  let ob = {communityID : comm.data.comm_id};
                  let gObj = {
                    id: window.btoa(JSON.stringify(ob)),
                    communityName : comm.data.comm_name,
                    communityID : comm.data.comm_id,
                    purpose : "login",
                    image_data: res.data.image_data
                  };
                  this.globalService.isLoginComm = gObj;
                  this.userService.isCommunity = window.btoa(JSON.stringify(ob));
                  let comObj = {
                    communityName : comm.data.comm_name,
                    communityID : comm.data.comm_id,
                    purpose : "login"
                  };
                  this.getclientData(window.btoa(JSON.stringify(comObj)));
                });
              }
            });
          }else{
            this.globalService.isLoginComm = {
              id: null,
              communityName : null,
              communityID : null,
              purpose : null,
              image_data: null
            };
            this.userService.isCommunity = null;
            this.getclientData(null);
          }
        }
      }
    });
  }

  changePasswordType() {
    this.passwordType = !this.passwordType
  }

  loginUser(signForm){
    $("#preloader").css('display','block');
    var signinObj = {
      user_name : this.user_name.toLowerCase(),
      password : this.password
    };

    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(signinObj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    };
    this.AuthService.login(authentication)
      .subscribe( sign =>{
        var resobj = JSON.parse(sign._body);

        this.validationMsg = resobj.message;
        this.loginStatusCode = resobj.statusCode;

        if(resobj.success){
          let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
          const usrRole = localStorage.getItem('userRole');
          if(usrRole == "Alignor Admin" || usrRole == "Game Author" || usrRole == "Translator"){
            lang_name = 'English';
          }
          this.translate.reloadLang(lang_name);

          let current_user = JSON.parse(localStorage.getItem('currentUser'));

          $("#preloader").css('display','none');

          if(current_user.user.community_user == true){
            // this.router.navigate(['/communityUser']);
            $('#successModal').modal('show');
          }else if(current_user.user.community_user == false){
            const Role = localStorage.getItem('userRole');
            if(Role == 'Alignor Admin'){
              /*if(current_user.user.question != ""){
                this.router.navigate(['/dashboard/portalDashboard']);
              } else {
                this.router.navigate(['/communityUser']);
              }*/
              $('#successModal').modal('show');
            }else if(Role == 'Community Admin'){
              if(current_user.user.question != ""){
                this.userService.getCommunityByCommunityID(resobj.data.community_id).subscribe(res => {
                  localStorage.setItem("activationStatus", res.data.activation_status);
                  localStorage.setItem("certificateManagement", res.data.config[0].certficate_mgmt);
                  /*this.router.navigate(['/dashboard/communityDashboard']);*/
                  $('#successModal').modal('show');
                });
              } else {
                /*this.router.navigate(['/communityUser']);*/
                $('#successModal').modal('show');
              }
            }else if(Role == 'Learner' || Role == 'Manager'){
              /*this.router.navigate(['/dashboard/learner/learnerDashboard']);*/
              localStorage.setItem('guideVideoSeenStatus', 'true');
              this.globalService.getTranslationTour();
              $('#successModal').modal('show');
            }else if(Role == 'Game Author'){
              /*if(current_user.user.question != ""){
                this.router.navigate(['/dashboard/spriteAnimation']);
              } else {
                this.router.navigate(['/communityUser']);
              }*/
              $('#successModal').modal('show');
            }else if(Role == 'Translator'){
              /*if(current_user.user.question != ""){
                this.router.navigate(['/dashboard/gameTranslate']);
              } else {
                this.router.navigate(['/communityUser']);
              }*/
              $('#successModal').modal('show');
            }
          }

          // Company Data
          const CompanyData = JSON.parse(localStorage.getItem('CompanyData'));
          if(CompanyData && CompanyData.communityID && CompanyData.communityID != 'global' && CompanyData.communityID != resobj.data.community_id){
            this.globalService.isLoginComm = {
              id: null,
              communityName : null,
              communityID : null,
              purpose : null,
              image_data: null
            };
            this.getclientData(null);
          }
        } else {
          $("#preloader").css('display','none');
          signForm.reset();
          $("#user_name").focus();
          this.loginflag = false;
        }
      });
  }

  clearValidation(txt){
    this.emailValidMsg = "";
    this.loginStatusCode = "";

    if(txt == 'USERNAME'){
      this.userService.getAllProtectedCommunity()
        .subscribe(comm =>{
          if(comm.success){
            this.AllCommunities = comm.data;
          }
        });
    } else if(txt == 'PASSWORD'){
      /*this.userService.getSecurityQuestions()
        .subscribe(questions =>{
          if(questions.success){
            this.securityQuestions = questions.data;
          }
        });*/
      this.router.navigate(['/isolatedForgotPWD']);

    }

    setTimeout(()=>{
      this.receiver = undefined;
      this.question = undefined;
    },100);
  }

  enterUserTab(e){
    if (e.keyCode == 13){
      this.userService.getAllProtectedCommunity()
        .subscribe(comm =>{
          if(comm.success){
            this.AllCommunities = comm.data;
            $("#userModal").modal('show');
          }
        });
    }
  }

  enterPwdTab(e){
    if (e.keyCode == 13){
      this.router.navigate(['/isolatedForgotPWD']);
    }
  }

  addNewUserRedirect(){
    this.loginStatusCode = "";
    this.alignorStstusCode = "";
    this.personalStstusCode = "";
    this.router.navigate(['/isolatedRegisterUser']);
  }

  getclientData(id: any) {

    this.userService.getClientData(id)
      .subscribe(result => {

        if (result == '' || result == null) {
        }else{
          this.companyName=result.data.communityName;
          if(this.companyName == 'None'){
            this.recoverUser = true;
          }else {
            this.recoverUser = false;
          }

          localStorage.setItem('CompanyData',JSON.stringify(result.data));
          if(result.data.purpose=='register'){
            this.router.navigate(['/isolatedRegisterUser']);
          }else {
            var communityID;
            const theCommunity = JSON.parse(localStorage.getItem('CompanyData'));
            if(theCommunity){
              communityID = theCommunity.communityID;
            } else {
              communityID = 'global';
            }
            if(communityID){
              this.userService.getCommunityByCommunityID(communityID)
                .subscribe(community =>{
                  if(community.success){
                    if(community.data){
                      if(community.data.privacy_protected){
                        this.privacyField = false;
                      } else {
                        this.privacyField = true;
                      }
                    }
                  }
                });
            }
          }
        }
      });
  }

  closeSuccessModal(){
    this.isDataShow = false;
    $('#successModal').modal('hide');
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  getWrapperHeight(){
    if(this.screenWidth == 1366){
      return this.screenHeight > 1000 ? '100vh' : '100%';
    }else{
      if(this.screenWidth >= 550 || this.screenWidth < 300){
        if(this.screenHeight > 1000){
          return this.screenWidth > 760 ? '100vh' : '100%';
        }else if(this.screenWidth > 1000){
          return '100vh';
        }else{
          return '100%';
        }
      }else {
        return '100vh';
      }
    }
  }

  ngOnDestroy(){
    $("body").removeClass("isolatedBg");
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-login/isolated-login.component.ts